
import { useContext, useEffect, useState, useRef } from 'react'
import axios from 'axios'
import Modal from 'react-modal'
import { useForm } from 'react-hook-form'

import { projectContext, loadingContext, urlValue, unfolder, closeModalVw, openModalVw, useTranslate } from '../../lib'
// import AsideBar from './AsideBar'

import './compliance-hits.scss'
import { customModal } from '../../styles/customModal'
import SideBar from '../../components/SideBar'
import TitleBar from '../../components/TitleBar'
import { useNavigate } from 'react-router-dom'
import ModalVw, { ModalBody, ModalContent, ModalHeader } from '../../components/common/ModalVw'
import Report from '../Report'
import ReportItem from './ReportItem'
// import MenuHeader from './MenuHeader'
// import trash from "../img/icons/trash.png"
// import expandleft from "../img/icons/Expand_left.svg"
// import searchicon from "../img/icons/search.svg"
// import editicon from "../img/icons/edit.png"
// import watchReport from "../img/icons/see-report-icon.jpg"

export default function ComplianceHits(props) {
    const { data, onSeekToTime, onToggle, toggles = {} } = props
    const [loading, setLoading] = useState(false)
    const [assement, setAssement] = useState(data)
    const { t } = useTranslate();

    useEffect(() => {
        setAssement(data)
    }, [data])

    const getClass =   (acurracy) => {
        if (acurracy < 50) {
            return 'red'
        }
        else if (acurracy > 50 && acurracy <= 80) {
            return 'orange'
        }
        else if (acurracy > 80) {
            return 'green'
        }
    }

    const getComplianceHits = () => {
        return assement.assesment.compliance.hits.map((item) => ({
            ...item,
            'class': getClass(item.accuracy)
        }));

    }

    const getResolutionHits = () => {
        return assement.assesment.resolution.hits.map((item) => ({
            ...item,
            'class': getClass(item.accuracy)
        }));
    }

    const getDisclaimerHits = () => {
        return assement.assesment.disclaimer.hits.map((item) => ({
            ...item,
            'class': getClass(item.accuracy * 100)
        }));
    }
    return (

        <>
            <div class="compliance">
                {assement.type == 'NLP' && <h3 className='font-bold text-[#36A9E1]'  >{t('reports.compliance')}</h3>}
                {getComplianceHits().map((item, index) => (
                    <div key={index} class="conversation conversation-suggested"  >
                        <div class="text-agent">
                            <div class="text">
                                <span className={item.class}>
                                    {item.used_phrase}
                                </span>
                                <img src={`/icons/triangle${item.class}.png`} alt="" />
                                {assement.type == 'NLP' && <b>{t('reports.weRecomend')}</b>}
                            </div>
                        </div>

                        <div class="text-client">
                            {item.suggested_phrase}
                        </div>
                        
                        {item.timestamp_start && item.timestamp_start !== 'unknown' && item.timestamp_start !== '00:00:00' && item.timestamp_start.trim() !== '' && (
                            <div class="text-client">
                                <span 
                                    style={{ cursor: 'pointer', color: '#0B5FA3' }}
                                    onClick={() => onSeekToTime && onSeekToTime(item.timestamp_start)}
                                >
                                    Recorded time: <span style={{ textDecoration: 'underline' }}>{item.timestamp_start}</span>
                                </span>
                            </div>
                        )}
                        {onToggle && (
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', padding: '5px 10px', gap: 8, fontSize: 12 }}>
                                <span style={{ color: '#4d4d4d' }}>{t('reports.isQuestionCorrect')}</span>
                                <label className="toggle-switch">
                                    <input type="checkbox"
                                        checked={toggles[`compliance|hits|${item.used_phrase || item.intent}`] ?? true}
                                        onChange={() => { onToggle(item, 'compliance', 'hits') }}
                                    />
                                    <span className="slider"></span>
                                </label>
                                <span style={{ color: '#0B5FA3', fontWeight: 'bold', minWidth: 20 }}>
                                    {toggles[`compliance|hits|${item.used_phrase || item.intent}`] ? t('common.yes') : t('common.no')}
                                </span>
                            </div>
                        )}
                    </div>
                ))}

                {assement.type == 'NLP' && <h3 className='font-bold text-[#36A9E1]'  > {t('reports.resolution')}</h3>}

                {getResolutionHits().map((item, index) => (

                    <div key={index} class="conversation conversation-suggested"  >
                        <div class="text-agent">
                            <div class="text">
                                <span className={item.class}>
                                    {item.used_phrase}
                                </span>
                                {assement.type == 'NLP' && <img src={`/icons/triangle${item.class}.png`} alt=""  />}
                                {assement.type == 'NLP' && <b>{t('reports.weRecomend')}</b>}
                            </div>
                        </div>

                        {assement.type !== 'NLP' && 
                        <div class="text-client">
                            <span>
                                <b>{((item?.isNumeric || 0) == 0) ? t('common.yes') : ((item?.accuracy || 0)/10).toFixed(1).toString() +'/10'}</b> {' ' + (item?.reason || '')}
                            </span>
                        </div>}
                        
                        <div class="text-client">
                            {item.suggested_phrase}
                        </div>
                        
                        {item.timestamp_start && item.timestamp_start !== 'unknown' && item.timestamp_start !== '00:00:00' && item.timestamp_start.trim() !== '' && (
                            <div class="text-client">
                                <span 
                                    style={{ cursor: 'pointer', color: '#0B5FA3' }}
                                    onClick={() => onSeekToTime && onSeekToTime(item.timestamp_start)}
                                >
                                    Recorded time: <span style={{ textDecoration: 'underline' }}>{item.timestamp_start}</span>
                                </span>
                            </div>
                        )}

                        {onToggle && (
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', padding: '5px 10px', gap: 8, fontSize: 12 }}>
                                <span style={{ color: '#4d4d4d' }}>{t('reports.isQuestionCorrect')}</span>
                                <label className="toggle-switch">
                                    <input type="checkbox"
                                        checked={toggles[`resolution|hits|${item.used_phrase || item.intent}`] ?? true}
                                        onChange={() => { onToggle(item, 'resolution', 'hits') }}
                                    />
                                    <span className="slider"></span>
                                </label>
                                <span style={{ color: '#0B5FA3', fontWeight: 'bold', minWidth: 20 }}>
                                    {toggles[`resolution|hits|${item.used_phrase || item.intent}`] ? t('common.yes') : t('common.no')}
                                </span>
                            </div>
                        )}
                    </div>))
                }

                {assement.type == 'NLP' && <h3  className='font-bold text-[#36A9E1]'  > {t('reports.disclaimer')}</h3>}

                {getDisclaimerHits().map((item, index) => (
                    <div class="conversation conversation-suggested"   >
                        <div class="text-agent">
                            <div class="text">
                                <span className={item.class}>
                                    {item.used_phrase}
                                </span>
                                <img src={`/icons/triangle${item.class}.png`} alt="" />
                                {assement.type == 'NLP' && <b>{t('reports.weRecomend')}</b>}
                            </div>
                        </div>
                        <div class="text-client">
                            {item.suggested_phrase}
                        </div>
                        
                        {item.timestamp_start && item.timestamp_start !== 'unknown' && item.timestamp_start !== '00:00:00' && item.timestamp_start.trim() !== '' && (
                            <div class="text-client">
                                <span 
                                    style={{ cursor: 'pointer', color: '#0B5FA3' }}
                                    onClick={() => onSeekToTime && onSeekToTime(item.timestamp_start)}
                                >
                                    Recorded time: <span style={{ textDecoration: 'underline' }}>{item.timestamp_start}</span>
                                </span>
                            </div>
                        )}

                        {onToggle && (
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', padding: '5px 10px', gap: 8, fontSize: 12 }}>
                                <span style={{ color: '#4d4d4d' }}>{t('reports.isQuestionCorrect')}</span>
                                <label className="toggle-switch">
                                    <input type="checkbox"
                                        checked={toggles[`disclaimer|hits|${item.used_phrase || item.intent}`] ?? true}
                                        onChange={() => { onToggle(item, 'disclaimer', 'hits') }}
                                    />
                                    <span className="slider"></span>
                                </label>
                                <span style={{ color: '#0B5FA3', fontWeight: 'bold', minWidth: 20 }}>
                                    {toggles[`disclaimer|hits|${item.used_phrase || item.intent}`] ? t('common.yes') : t('common.no')}
                                </span>
                            </div>
                        )}
                    </div>))}
            </div>


        </>


    )
}
